angular
    .module("iFAST.common")
    .factory("restSvc", ["$resource", "$rootScope", "logoutSvc", function ($resource, $rootScope, logoutSvc) {
        "use strict";

        /* globals BOOMR */
        var createResource = function(additionalActionOption){
            var action = {
                query: {method: "POST", isArray: false},
                save: {method: "POST", isArray: false}
            };

            if(angular.isObject(additionalActionOption)) {
                angular.extend(action.query, additionalActionOption);
                angular.extend(action.save, additionalActionOption);
            }

            return $resource(restSrvcContextRoot + URL_RESOURCE + URL_PARAM,
                {type: "@type", method: "@method"}, action);
        }

        var sendBoomr = function(timer,boomrVar) {
            return function() {
                if(timer) {
                    //Add additional BOOMR variables to the request.
                    if (boomrVar) {
                        BOOMR.addVar(boomrVar);
                    }
                    timer.loaded(); }
            };
        };

        var getBoomrVars = function ( typeMethod ){
            var restURL = restSrvcContextRoot + URL_RESOURCE + typeMethod.type + "/" + typeMethod.method;
            var boomrVar = {"rest":restURL};
            return boomrVar;
        };

        var query = function (typeMethod, params, additionalActionOption) {
            var timer = BOOMR.requestStart("query");
            var boomrVar = getBoomrVars(typeMethod);
            var localResource = angular.isObject(additionalActionOption)
                ? createResource(additionalActionOption)
                : resource;
            var response = localResource.query(typeMethod, params);

            response.$promise["catch"](errorHandler(typeMethod));
            response.$promise.then(sendBoomr(timer,boomrVar));

            return response;
        };

        var save = function (typeMethod, params) {
            var timer = BOOMR.requestStart("save");
            var response = resource.save(typeMethod, params);
            var boomrVar = getBoomrVars(typeMethod);
            response.$promise["catch"](errorHandler(typeMethod));
            response.$promise.then(sendBoomr(timer,boomrVar));
            return response;
        };

        var restSrvcContextRoot = "";
        var URL_RESOURCE = "rest/json/";
        var URL_PARAM = ":type/:method";

        var resource = createResource();

        var errorHandler = function (typeMethod) {
            return function (response) {
                window.console.log(response);

                var timeoutRedirectUrl = $rootScope.userInfo.timeoutRedirectUrl;
                var isClientSiteUrl = (undefined !== timeoutRedirectUrl && null !== timeoutRedirectUrl && timeoutRedirectUrl.lastIndexOf("http", 0) === 0);
                if (null !== response && (408 === response.status || 0 === response.status) && ("bob" !== typeMethod.type || "reportstatus" !== typeMethod.method) && (typeMethod.method !=="adhocStatementInquiry")) {
                    var errMsg = (true === $rootScope.userInfo.ssoUser || "true" === $rootScope.userInfo.ssoUser || isClientSiteUrl)? null : "timeoutErrorMsg";
                    logoutSvc.logout(errMsg, timeoutRedirectUrl);
                }
            };
        };

        return {
            query: query,
            save: save
        };
    }]);


// WEBPACK FOOTER //
// ./WebContent/src/_common/services/shared/rest-service.js